angular.module('rjmNg.directives').directive 'manageUsers', [
  () ->
    restrict: 'E'
    templateUrl: 'settings/directive.manageUsers.html'
    replace: true
    scope: {}
    controllerAs: 'view'
    bindToController: true
    require: "^?rjmUi"
    controller: [
      "$routeParams"
      "notification"
      "app"
      "USER_PERMISSION"
      "$clientAppUrl"
      "Metrics"
      "$scope"
      "$http"
      "$url"
      "$timeout"
      "StructureCache"
      "$q"
      "errorConstants"
      "userService"
      "Dashboard"
      "Users"
      "Clients"
      (
        $routeParams
        notification
        app
        USER_PERMISSION
        $clientAppUrl
        Metrics
        $scope
        $http
        $url
        $timeout
        StructureCache
        $q
        errorConstants
        userService
        Dashboard
        Users
        Clients
      ) ->

        view = @

        _init = (userId, tabId) -> 
          view.users = []
          view.selectedTab = 'Permissions'
          view.selectedUserId = 5
          view.userSearchText = ''
          view.selectedUserInfo = {}
          view.isAdvancedUserMng = false
          view.inviteMembersUrl = $clientAppUrl "/settings/user/invite"
          view.inviteMembersUrlV1 = $clientAppUrl "/settings/user/access-group"
          view.clientId = $routeParams.clientId

          view.accessOptions = USER_PERMISSION.ACCESS

          view.metrics = []
          view.tables = []
          view.allDashboards = []
          view.isLoading = true 

          Clients.get($routeParams.clientId)
            .then ({properties}) ->
              {is_group_store_access} = properties
              view.isAdvancedUserMng = is_group_store_access is "1"
              if view.isAdvancedUserMng
                fetchOptionsFromAPI()
              
          $q.all([
            Metrics.get(view.clientId),
            StructureCache.getStructure(),
            userService.query({clientId: view.clientId}),
            Dashboard.query({clientId: view.clientId})
          ]).then(
            (response) ->
              [metrics, structure, oldUsers, allDashboards] = response
              view.metrics = metrics
              view.tables = []
              view.tables.push table for id, table of structure.tables
              view.tableHasMetric = Metrics.buildTableHasMetricMap(view.tables, view.metrics)
              view.users = oldUsers
              view.selectUser(userId or app.getUserId())
              view.allDashboards = allDashboards
              if tabId
                view.selectTab(tabId)
            , (error) ->
              notification.error(
                "Server Error",
                errorConstants.SERVER_ERROR_MESSAGE,
                "manage-users",
                null,
                15
              )
          ).finally ->
            # Set loading state to false after all promises are resolved
            view.isLoading = false

        view.hasMetric = (table) ->
          return view.tableHasMetric[table.id]

        view.inTable = (table) ->
          (metric) ->
            selectedMetric = view.metrics.filter((m) -> 
              m.id is metric.id 
            )[0]
            return selectedMetric.table_id is table.id

        view.selectTab = (tabId) ->
          view.selectedTab = tabId

        view.selectUser = (userId) -> 
          view.selectedUserId = userId

          selectedUser = view.users.filter((user) ->
            user.id is userId
          )[0]

          angular.copy(selectedUser, view.selectedUserInfo)

          view.clientRights = view.selectedUserInfo.client_rights
          view.isAdmin = view.clientRights.is_admin

          if view.clientRights.is_admin
            view.selectedAccess = USER_PERMISSION.ACCESS.ADMIN
          else if (view.clientRights.is_readonly) 
            view.selectedAccess = USER_PERMISSION.ACCESS.READONLY
          else 
            view.selectedAccess = USER_PERMISSION.ACCESS.STANDARD

          view.metrics = _.map(view.metrics, (item) -> 
            _.extend(item, _.findWhere(view.selectedUserInfo.trend_rights, {id: item.id}))
          ).filter((metrics) -> metrics.id)

          view.metricToggled()
          view.dashboardToggled()
          view.updateView()

          if view.isAdmin
            view.clientRights.trend_rights.forEach((metric) ->
              metric.has_rights = true
            )

        $scope.view ?= {}
        $scope.option ?= {}
        $scope.option.userGroup ?= {}
        $scope.view.storeSelect ?= []
        $scope.view.filteredStoreSelect = []
        allSelected = true
        groupData = []
        storeData = []
        view.updateView = () ->
          if (not view.selectedUserInfo.client_rights.is_admin) and view.selectedUserInfo.client_rights.aumEnabled
            view.dashboardPermissions = [
              'View',
              'None'
            ]
          else
            view.dashboardPermissions = [
              'Edit',
              'View',
              'None'
            ]

          $scope.view.groupSelect = groupData
          $scope.view.storeSelect = storeData
          view.selectedGroup = view.selectedUserInfo?.access_group?.id
          view.isStoresFiltered = view.selectedUserInfo?.access_group?.isStoresFiltered ? []
          view.selectedStores = if view.isStoresFiltered then view.selectedUserInfo?.access_group?.stores ? [] else []
        
          defaultGroup = groupData.find (group) -> group.id == 0
          if view.selectedGroup? and view.selectedGroup != 0
            selectedGroup = groupData.find (group) -> group.id == view.selectedGroup
            if selectedGroup
              $scope.option.userGroup = selectedGroup
              if view.isStoresFiltered == 1
                $scope.option.userStores = if view.selectedStores.length > 0 then view.selectedStores else storeData.map((store) -> store.id)
              else
                $scope.option.userStores = storeData.map((store) -> store.id)
              $scope.updateFilteredStoreSelect(view.selectedGroup)
            else if defaultGroup
              $scope.option.userGroup = defaultGroup
              $scope.option.userStores = storeData.map((store) -> store.id)
              $scope.updateFilteredStoreSelect(defaultGroup.id)
          else if defaultGroup
            $scope.option.userGroup = defaultGroup
            $scope.option.userStores = storeData.map((store) -> store.id)
            $scope.updateFilteredStoreSelect(defaultGroup.id)
        
        fetchOptionsFromAPI = ->
          allStores = []
          userService.stores({clientId: view.clientId}).then (response) ->
            allStores = response.data

            groupData = []
            storeData = []
            listAccessGroup = (userGroup) ->
              if userGroup.id? and userGroup.name?
                groupData.push({ id: userGroup.id, name: userGroup.name })
                if Array.isArray(userGroup.stores) and userGroup.stores.length > 0
                  for store in userGroup.stores
                    if store.id? and store.name?
                      storeData.push({ id: store.id, name: store.name, groupId: userGroup.id, groupName: userGroup.name, selected: false })

            # Check if allStores is an array
            if Array.isArray(allStores)
              for userGroup in allStores
                listAccessGroup(userGroup)
            else if typeof allStores is 'object' and allStores isnt null
              listAccessGroup(allStores)
            
            # Assign groupData and storeData to view for external access
            $scope.view.groupSelect = groupData
            $scope.view.storeSelect = storeData
            
            view.updateView()

          , (error) ->
            # notification.error("Server Error",
            #   errorConstants.SERVER_ERROR_MESSAGE,
            #   "manage-users",
            #   null,
            #   15
            # )
        # Function to update the filtered store list based on the selected user group
        $scope.updateFilteredStoreSelect = (groupId) ->
          $scope.view.filteredStoreSelect = $scope.view.storeSelect.filter (store) ->
            store.groupId == groupId

        # Function to save selected group access
        saveSelectedGroupAccess = ->
          groupedStores = {}
          mainGroupId = $scope.option.userGroup.id

          # Initialize the main group in groupedStores
          groupedStores = {
            id: mainGroupId,
            stores: []
          }
          # Track if any store is unselected
          for store in $scope.view.storeSelect
            if store.groupId == mainGroupId
              if store.selected
                groupedStores.stores.push(store.id)
              else
                allSelected = false

          if allSelected
            groupedStores.stores = []

          $scope.view.selectedUserInfo.access_groups = groupedStores 
          

        
        # Watch for changes in selected user group to update store selections
        $scope.$watch('option.userGroup', (newVal) ->
          if newVal
            groupId = newVal.id
            $scope.updateFilteredStoreSelect(groupId)
            for store in $scope.view.storeSelect
              store.selected = store.groupId == groupId
            saveSelectedGroupAccess()
        , true)

        # Watch for changes in store selection to update selected group access
        $scope.$watch('view.storeSelect', (newVal) ->
          saveSelectedGroupAccess()
        , true)

        # Dropdown functionality
        initializeDropdown = ->
          searchInput = document.querySelector(".manage-users__tab-content .search-input")
          dropdownList = document.querySelector(".manage-users__tab-content .dropdown-list")
          options = []

          if not searchInput or not dropdownList
            return

          searchInput.addEventListener("input", () ->
            searchTerm = searchInput.value.toLowerCase()
            options = dropdownList.querySelectorAll("li")
            options.forEach((option) ->
              optionText = option.textContent.toLowerCase()
              if optionText.includes(searchTerm)
                option.style.display = "flex"
              else
                option.style.display = "none"
            )
          )

          document.addEventListener("click", (event) ->
            if not (event.target is searchInput)
              dropdownList.style.display = "none"
          )

          searchInput.addEventListener("click", () ->
            dropdownList.style.display = "block"
          )

          options.forEach((option) ->
            option.addEventListener("click", () ->
              checkbox = option.querySelector("input[type='checkbox']")
              checkbox.checked = !checkbox.checked
              searchInput.value = option.textContent.trim()
              dropdownList.style.display = "none"
            )
          )

        # Use $timeout to ensure elements are rendered before initialization
        $timeout ->
          initializeDropdown()
        , 0

        # Observer to watch for changes in the DOM
        observer = new MutationObserver (mutations) ->
          mutations.forEach (mutation) ->
            if mutation.type is 'childList'
              searchInput = document.querySelector(".manage-users__tab-content .search-input")
              dropdownList = document.querySelector(".manage-users__tab-content .dropdown-list")
              if searchInput and dropdownList
                initializeDropdown()
                observer.disconnect() # Disconnect observer after initialization to prevent redundant calls

        # Start observing for DOM changes
        observer.observe document.body, { childList: true, subtree: true }

        view.getSharingStatus = (dashboard) ->
          if !dashboard.is_syndicated
            'None'
          else
            if dashboard.syndicated_permission is 1
              'View'
            else if dashboard.syndicated_permission is 2
              'Edit'

        view.dashboardPermissions = [
          'Edit',
          'View',
          'None'
        ]

        view.setDashboardPermissions = (permission, dashboards) ->
          isSyndicated = false
          permissionLevel = 0
          if permission isnt 'None'
            isSyndicated = true
            if permission is 'Edit'
              permissionLevel = 2
            else if permission is 'View'
              permissionLevel = 1

          if dashboards instanceof Array
            dashboards.filter((dashboard) ->
              dashboard.is_selected
            ).forEach((dashboard) ->
              dashboard.is_syndicated = isSyndicated
              dashboard.syndicated_permission = permissionLevel
            )
          else
            dashboards.is_syndicated = isSyndicated
            dashboards.syndicated_permission = permissionLevel


        view.dashboardToggled = () ->
          view.isAllDashboardsSelected = view.selectedUserInfo.dashboards.every((dashboard) ->
            dashboard.is_selected
          )

        view.toggleAllDashboards = () ->
          view.selectedUserInfo.dashboards.forEach((dashboard) ->
            dashboard.is_selected = view.isAllDashboardsSelected
          )

        view.metricToggled = () ->
          view.isAllMetricsSelected = view.clientRights.trend_rights.every((metric) ->
            metric.has_rights
          )

        view.toggleAllMetrics = () ->
          view.clientRights.trend_rights.forEach((metric) ->
            metric.has_rights = view.isAllMetricsSelected
          )

        view.deactivateUser = () ->
          Users.delete(view.selectedUserId, view.clientId)
            .then (response) ->
              notification.success(null, "User was successfully deactivated.", "manage-users", { dismissable: true, bindHtml: true }, 5)
              _init()
            .catch (error) ->
              notification.error(null, "User was not successfully deactivated. Please try again.", "manage-users", { dismissable: true, bindHtml: true }, 5)

        view.updateSettings = () ->
          # update permissions (user)
          switch view.selectedAccess
            when USER_PERMISSION.ACCESS.ADMIN
              view.clientRights.is_admin = true
              view.clientRights.is_readonly = false
            when USER_PERMISSION.ACCESS.READONLY
              view.clientRights.is_readonly = true
              view.clientRights.is_admin = false
            else
              view.clientRights.is_admin = false
              view.clientRights.is_readonly = false
          saveSelectedGroupAccess()

          userService.update(view.selectedUserInfo)
            .then (response) ->
              notification.success(null, "User was successfully updated.", "manage-users", { dismissable: true, bindHtml: true }, 5)
              _init(view.selectedUserId, view.selectedTab)
            .catch (error) ->
              if error.data.error?
                notification.error(null, error.data.error, "manage-users", { dismissable: true, bindHtml: true }, 5)
              else
                notification.error(null, "User was not successfully updated. Please try again.", "manage-users", { dismissable: true, bindHtml: true }, 5)
        @$onInit = () ->
          _init()

        view
    ]
    link: (scope, element, attributes, rjmUi) ->

      scope.$watch "view.isLoading", (newVal, oldVal) ->
        rjmUi?.loadingUi "connection-picker", newVal, ""
]
